<fieldset [class.expanded]="expanded">
  @if (!expanded) {
  <div class="content">
    <div class="row">
      @for (field of fieldList; track field) {
      <div class="d-flex col-12">
        <field-label [field]="field" [notRequired]="true"></field-label>
        <div #customValueView [hidden]="customValueView.children.length === 0">
          <ng-content select="[value]"></ng-content>
        </div>
        @if (customValueView.children.length === 0) {
        <field-value
          class="line"
          [field]="field"
          emptyMessage="This field has not been set yet"
        ></field-value>
        }
      </div>
      }
    </div>
    @if (!disabled) {
    <div class="edit"><a (click)="expand()">edit</a></div>
    }
  </div>
  } @if (expanded) {
  <div class="content" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form [formGroup]="form" (submit)="submit()">
      @for (field of fieldList; track field) {
      <div class="row col-12">
        <field-notes [field]="field"></field-notes>
        <field-label [field]="field"></field-label>
        <div class="control-wrap">
          <div class="control">
            <field-control
              [field]="field"
              (changedField)="checkUnsavedField($event)"
              [class]="controlSize"
            ></field-control>
            <field-tooltip [tooltip]="field.attributes.tooltip"></field-tooltip>
          </div>
          <field-errors [controls]="form.controls[field.name]"></field-errors>
        </div>
      </div>
      }
      <submit-control
        [loading]="loading"
        (cancel)="cancel()"
        (onSubmit)="saveClicked()"
        >Save changes</submit-control
      >
    </form>
  </div>
  }
</fieldset>
